<div
  *ngIf="contextData.context$ | async as context"
  class="eb-form__field eb-form__field--approval-of-data-policy eb-form__field--checkbox eb-form__field--required"
>
  <span class="eb-form__field-label-content">
    {{ 'rfp.approvalOfDataPolicy.header' | cxTranslate }}
  </span>
  <label class="eb-form-field__tickable">
    <input
      name="approvalOfDataPolicy"
      type="checkbox"
      value="1"
      (keydown)="onChange($event.target, context.control)"
      (change)="onChange($event.target, context.control)"
      [checked]="context.control.value === '1'"
      [attr.error]="(context.control.invalid && context.control.touched) || undefined"
      [attr.disabled]="context.disabled || undefined"
    />
    <span *ngIf="linkComponent$ | async as linkComponent">
      {{ 'rfp.approvalOfDataPolicy.option.pre.label' | cxTranslate }}
      <cx-generic-link
        [url]="linkComponent.url"
        [target]="linkComponent.target"
        [style]="linkComponent.styleAttributes"
        [class]="linkComponent.styleClasses"
      >
        {{ linkComponent.linkName }}
      </cx-generic-link>
      {{ 'rfp.approvalOfDataPolicy.option.post.label' | cxTranslate }}
    </span>
  </label>
</div>
